// extracted by mini-css-extract-plugin
export var personalSocialLinks = "PersonalSocialLinks_personalSocialLinks__LUiBi";
export var rotate = "PersonalSocialLinks_rotate__N39qs";
export var dotty = "PersonalSocialLinks_dotty__TKqNw";